import './index.css'
import line from '../../assets/shapes_svg/sections/line.svg'
import info from '../../assets/shapes_svg/sections/info.svg'
import supply from '../../assets/shapes_svg/sections/supply.svg'
import truck from '../../assets/shapes_svg/sections/truck.svg'
import infoselected from '../../assets/shapes_svg/sections/infoselected.svg'
import supplyselected from '../../assets/shapes_svg/sections/supplyselected.svg'
import truckselected from '../../assets/shapes_svg/sections/truckselected.svg'
import { useState, useEffect } from 'react'

const Sections = ({selected,setSection}) => {
    const [infoState,setInfo] = useState(info)
    const [supplyState,setSupply] = useState(supply)
    const [truckState,setTruck] = useState(truck)
    
    useEffect (() => {
        if (selected){
            if (selected == 1){
                setInfo(infoselected)
                setTruck(truck)
                setSupply(supply)
            } else if (selected == 2){
                setInfo(info)
                setTruck(truckselected)
                setSupply(supply)
            } else if (selected == 3){
                setInfo(info)
                setTruck(truck)
                setSupply(supplyselected)
            } 
        }
    },[selected])

    return ( 
        <div className="sections">
            <div onClick={() => setSection(1)} className={"sections__section" + (selected ==1 ? " sections__selected" : "" )}>
                <img src={infoState} alt="" />
            </div>
            <img className='sections__line' style={{position:"relative",left:"-8px"}} src={line} alt="" />
            <div onClick={() => setSection(2)} className={"sections__section" + (selected ==2 ? " sections__selected" : "" )}>
                <img style={{position:"relative",left:"-13px"}} src={truckState} alt="" />
            </div>
            <img className='sections__line' style={{position:"relative",left:"-18px"}} src={line} alt="" />
            <div onClick={() => setSection(3)} className={"sections__section" + (selected ==3 ? " sections__selected" : "") }>
                <img style={{position:"relative",left:"-23px"}} src={supplyState} alt="" />
            </div>
            
        </div>
     );
}
 
export default Sections;